import React from 'react';

// import components
import Projects from './Projects';

const Portfolio = () => {
  return (
    <section id='portfolio' className='section bg-primary min-h-[1400px]'>
      <div className='container mx-auto'>
        <div className='flex flex-col items-center text-center'>
          <h2 className='section-title  relative before:absolute before:opacity-40 before:-top-[2rem] before:-left-3/4 before:hidden before:lg:block'>
            My latest work
          </h2>
          <p className='subtitle'>
            I have been complete 10+ project last 6 month . Here i'm showing some best project . If you want to  see others project just go to my   <a className='text-xl' href="https://github.com/EmtiazHossainE2" target="_blank" rel="noopener noreferrer">Github</a> repository .
          </p>
        </div>
        <Projects />
      </div>
    </section>
  );
};

export default Portfolio;
